import React from 'react';
import { motion } from 'framer-motion';
import { Search, MapPin, Users, Wifi, Utensils, Zap, Filter, ArrowRight, Calendar } from 'lucide-react';
import { Button } from '../components/Button';
import { cn } from '../utils/cn';
export function AvailableHomesPage() {
  const properties = [{
    id: 1,
    name: 'The Silver Spring Nest',
    address: '123 Main St, Silver Spring, MD 20910',
    county: 'Montgomery',
    beds: 2,
    availability: 'Available',
    img: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&q=80&w=800',
    amenities: ['Wi-Fi', 'Laundry', 'Parking', 'Near Metro']
  }, {
    id: 2,
    name: 'Baltimore Harbor View',
    address: '456 Harbor Dr, Baltimore, MD 21202',
    county: 'Baltimore City',
    beds: 1,
    availability: 'Limited',
    img: 'https://images.unsplash.com/photo-1576941089067-2de3c901e126?auto=format&fit=crop&q=80&w=800',
    amenities: ['Wi-Fi', 'Furnished', 'Utilities Incl.', 'Bus Access']
  }, {
    id: 3,
    name: 'Towson Community Home',
    address: '789 College Ave, Towson, MD 21204',
    county: 'Baltimore County',
    beds: 0,
    availability: 'Waitlist',
    img: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80&w=800',
    amenities: ['Wi-Fi', 'Quiet Area', 'Modern Kitchen', 'Garden']
  }, {
    id: 4,
    name: 'Bethesda Quiet Living',
    address: '321 Elm St, Bethesda, MD 20814',
    county: 'Montgomery',
    beds: 3,
    availability: 'Available',
    img: 'https://images.unsplash.com/photo-1580587767503-3997f19c52c0?auto=format&fit=crop&q=80&w=800',
    amenities: ['Wi-Fi', 'Private Rooms', 'Security', 'Near Shops']
  }];
  return <div className="w-full" data-id="element-148">
      {/* Header */}
      <section className="py-20 bg-primary text-white px-6" data-id="element-149">
        <div className="max-w-7xl mx-auto" data-id="element-150">
          <h1 className="text-5xl font-display font-bold mb-6" data-id="element-151">
            Available Homes
          </h1>
          <p className="text-xl text-white/70 max-w-2xl" data-id="element-152">
            Find your next home in one of our professionally managed residential
            communities across Maryland.
          </p>
        </div>
      </section>

      {/* Filters */}
      <section className="sticky top-[72px] z-40 bg-white border-b border-gray-100 px-6 py-4 shadow-sm" data-id="element-153">
        <div className="max-w-7xl mx-auto flex flex-wrap items-center gap-4" data-id="element-154">
          <div className="flex-1 min-w-[200px] relative" data-id="element-155">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted" size={18} data-id="element-156" />
            <input type="text" placeholder="Search by city or zip..." className="w-full pl-10 pr-4 py-2 bg-gray-50 border-none rounded-lg focus:ring-2 focus:ring-primary" data-id="element-157" />
          </div>
          <select className="px-4 py-2 bg-gray-50 border-none rounded-lg focus:ring-2 focus:ring-primary appearance-none min-w-[150px]" data-id="element-158">
            <option data-id="element-159">All Counties</option>
            <option data-id="element-160">Baltimore City</option>
            <option data-id="element-161">Baltimore County</option>
            <option data-id="element-162">Montgomery County</option>
          </select>
          <select className="px-4 py-2 bg-gray-50 border-none rounded-lg focus:ring-2 focus:ring-primary appearance-none min-w-[150px]" data-id="element-163">
            <option data-id="element-164">Any Gender</option>
            <option data-id="element-165">Male Only</option>
            <option data-id="element-166">Female Only</option>
          </select>
          <select className="px-4 py-2 bg-gray-50 border-none rounded-lg focus:ring-2 focus:ring-primary appearance-none min-w-[150px]" data-id="element-167">
            <option data-id="element-168">Availability</option>
            <option data-id="element-169">Available Now</option>
            <option data-id="element-170">Waitlist</option>
          </select>
          <Button size="sm" className="flex items-center space-x-2" data-id="element-171">
            <Filter size={16} data-id="element-172" />
            <span data-id="element-173">Apply Filters</span>
          </Button>
        </div>
      </section>

      {/* Property Grid */}
      <section className="py-20 px-6 bg-background" data-id="element-174">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-175">
          {properties.map(property => <motion.div key={property.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl overflow-hidden shadow-premium border border-gray-100 flex flex-col lg:flex-row" data-id="element-176">
              <div className="lg:w-2/5 relative h-64 lg:h-auto" data-id="element-177">
                <img src={property.img} alt={property.name} className="w-full h-full object-cover" data-id="element-178" />
                <div className={cn('absolute top-4 left-4 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider', property.availability === 'Available' ? 'bg-green-500 text-white' : property.availability === 'Limited' ? 'bg-accent text-charcoal' : 'bg-gray-500 text-white')} data-id="element-179">
                  {property.availability}
                </div>
              </div>
              <div className="lg:w-3/5 p-8 flex flex-col" data-id="element-180">
                <div className="flex justify-between items-start mb-4" data-id="element-181">
                  <div data-id="element-182">
                    <div className="text-xs font-bold text-accent uppercase tracking-widest mb-1" data-id="element-183">
                      {property.county} County
                    </div>
                    <h3 className="text-2xl font-bold text-charcoal" data-id="element-184">
                      {property.name}
                    </h3>
                  </div>
                </div>

                <div className="flex items-center text-muted text-sm mb-6" data-id="element-185">
                  <MapPin size={16} className="mr-2 shrink-0" data-id="element-186" />
                  <span data-id="element-187">{property.address}</span>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-188">
                  <div className="flex items-center space-x-2 text-sm text-charcoal font-medium" data-id="element-189">
                    <Users size={16} className="text-primary" data-id="element-190" />
                    <span data-id="element-191">{property.beds} Beds Available</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-charcoal font-medium" data-id="element-192">
                    <Calendar size={16} className="text-primary" data-id="element-193" />
                    <span data-id="element-194">Move-in Ready</span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2 mb-8" data-id="element-195">
                  {property.amenities.map(amenity => <span key={amenity} className="px-3 py-1 bg-gray-50 text-muted text-xs font-bold rounded-full border border-gray-100" data-id="element-196">
                      {amenity}
                    </span>)}
                </div>

                <div className="mt-auto grid grid-cols-2 gap-4" data-id="element-197">
                  <Button variant="primary" data-id="element-198">Apply Now</Button>
                  <Button variant="outline" data-id="element-199">Schedule Tour</Button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>

      {/* Map Preview Placeholder */}
      <section className="py-20 px-6" data-id="element-200">
        <div className="max-w-7xl mx-auto" data-id="element-201">
          <div className="bg-gray-200 rounded-3xl h-[400px] flex items-center justify-center relative overflow-hidden" data-id="element-202">
            <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&q=80&w=2000" alt="Map" className="w-full h-full object-cover opacity-50" data-id="element-203" />
            <div className="absolute inset-0 bg-primary/10" data-id="element-204" />
            <div className="relative z-10 text-center space-y-4" data-id="element-205">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-primary mx-auto shadow-xl" data-id="element-206">
                <MapPin size={32} data-id="element-207" />
              </div>
              <h3 className="text-2xl font-bold text-charcoal" data-id="element-208">
                Interactive Map View
              </h3>
              <p className="text-muted" data-id="element-209">
                Explore all our locations and nearby amenities.
              </p>
              <Button variant="primary" data-id="element-210">Launch Full Map</Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}